
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as accessibilitei0RjQtkRlRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/accessibilite.vue?macro=true";
import { default as _91slug_93MjbUFOY9g0Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/activites/[slug].vue?macro=true";
import { default as editZ9BDYmxDwLMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as indexYjKDbbGQ2UMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as addldxWt0FPQrMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexpIYVM9MA0UMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/index.vue?macro=true";
import { default as editT5P6luTmVOMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as addaCHa7XruvbMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as index13C5tnu0hRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as editBlf7yMDCvNMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as indexA4X8wDC3bCMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as addh7dmgJkjYlMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as index14rO8OiVFHMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as postsICxDm6CTAfMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/posts.vue?macro=true";
import { default as editAzuvar4mDPMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as index8CyEFcai3zMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as adddUo0mzw85LMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as indexYEEAAP2ZgoMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as editooAdIErDbrMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as addYaDY090ApsMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as indexxmpJicPyY3Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as editkIYnVF5eFeMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexrtGEGgk97dMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as addQjRooXz8SWMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexgqP448s5HzMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as editmVRy6HGwMZMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as indexOjN4TfRDmRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indexP0AzkBXjJCMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/index.vue?macro=true";
import { default as benevoles_45informationszDiT0xr2wRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as benevoleswA52jTHp6cMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as datesQfMlt1vnZxMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexO70ptcbQ46Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/index.vue?macro=true";
import { default as informationsJxX0gUbSZCMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as lieuxBPb90942j5Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as responsables3YHF51zEULMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as titleVWX8wZxjJIMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexZFJYnf1s6wMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as redirectqSzyNBZjTuMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as visuelyNgDTNTkj3Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexEH8r8OcFZVMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/index.vue?macro=true";
import { default as notesDwzqguMzZHMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/notes.vue?macro=true";
import { default as diffusionsEiL13ObrtaMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as editjM3sVEp0wlMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as indexkcfJ6Bh6jmMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as addp4AqtDeFkkMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as indexaeSuofa6osMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/index.vue?macro=true";
import { default as invitations3L3wJf269TMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/other/invitations.vue?macro=true";
import { default as logsmvIhhmbifVMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/other/logs.vue?macro=true";
import { default as indexUH9eNgevgMMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/participations/index.vue?macro=true";
import { default as ressourcesQ3k4sWd3H4Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/ressources.vue?macro=true";
import { default as emailsJ8ZSiYvD8aMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/emails.vue?macro=true";
import { default as messagesHkyq3d4E16Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/messages.vue?macro=true";
import { default as edit1RrMAosDDuMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as pending_45items7GgpAwS9i8Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as addpj5eqfrtBcMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexD0T62kdw6mMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/index.vue?macro=true";
import { default as trafic_45entrant3VttttFMI0Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortant3FnEghnPioMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as conversionsY0jC1Pr03dMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/conversions.vue?macro=true";
import { default as missions_45a_45validerLicxeDwDugMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesX5pb4OrQYkMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as organisations_45a_45validerH7sUP4zkDPMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as indexmSy5SMRgonMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/index.vue?macro=true";
import { default as indicateurs_45clescWXojrS7PxMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as missionsqgH4Rpt5eOMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/missions.vue?macro=true";
import { default as indexVckT9IlyvUMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as missions_45perimeesxWgJjmNwrWMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as participations_45a_45validerwTt64Aw5c8Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesc2T2JCJ4B8Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as participationsIrLHNIrSpXMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/participations.vue?macro=true";
import { default as placesCB333CxIqvMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/places.vue?macro=true";
import { default as moderationsh6Rl33nPIRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as utilisateursQDolqD7OGVMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as editoC6pCd3dBLMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as add6wYrCYcPaYMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as index9QAZ4uOHUmMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as temoignagesTcauOTGt6MMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/temoignages.vue?macro=true";
import { default as editX1xPT6XxooMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as indexB6jNyg8sLuMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexYCrZaghJWlMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/utilisateurs/index.vue?macro=true";
import { default as _91slug_93O6YzixbBcbMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/associations/[slug].vue?macro=true";
import { default as benevolesjPH7hzTzpnMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as indexUlbAsD6RyrMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as responsablesex0EaTq5RqMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as charte_45reserve_45civiquepsMlW47En1Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-reserve-civique.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationeHqpZSAa90Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexCrtR51D8F4Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/dashboard/index.vue?macro=true";
import { default as _91slug_93OFyXss1hPnMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/departements/[slug].vue?macro=true";
import { default as _91slug_93DQe0ukCjrOMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/domaines-action/[slug].vue?macro=true";
import { default as en_45ce_45momentJTV7XPRV7GMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/en-ce-moment.vue?macro=true";
import { default as indexffTf0oiqUyMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/index.vue?macro=true";
import { default as indexOfaOObQXQLMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/index.vue?macro=true";
import { default as competencesFbp85HYJ42Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as disponibilitesAVhUebn1QGMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as preferencesAs2VMDZjSdMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as profilebN2WFp0XWiMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as indexkvoMtPseFdMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/index.vue?macro=true";
import { default as index6g68Z3b83GMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/index.vue?macro=true";
import { default as charte_45bon_45fonctionnement8rqAmt1oiMMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationkCzX0cfI2SMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as collectiviteHHnQAVH04TMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisation_45confirmationhZGjn1aysiMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as organisation_45detailsH3cI16jaU0Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as organisation_45imagescXTrL31mrvMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisationxozseg4f61Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as profileiC9MYR92IcMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as _91hash_93ycdj7IRycEMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/invitations/[hash].vue?macro=true";
import { default as loginDj5qGS2X7WMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/login.vue?macro=true";
import { default as admin4UbNCgiu7UMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/maintenance/admin.vue?macro=true";
import { default as indexudKrwgck8vMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/maintenance/index.vue?macro=true";
import { default as mentions_45legalesdmOVjrAskRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/mentions-legales.vue?macro=true";
import { default as _91id_93c4vqxyU5JQMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/[id].vue?macro=true";
import { default as index8dA3ECBcg0Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/index.vue?macro=true";
import { default as addVkIjW0u71lMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/modeles/add.vue?macro=true";
import { default as indexr9RAjLh5e8Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/modeles/index.vue?macro=true";
import { default as _91slug_93AFk00fKW50Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as indexEo5nIVpHyBMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as indexXc6YqUwGDMMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/missions-benevolat/index.vue?macro=true";
import { default as notificationsIVMeRX5iroMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/notifications.vue?macro=true";
import { default as _91slug_932no4vIV64iMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/organisations/[slug].vue?macro=true";
import { default as indexIHlKN95VDeMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/organisations/index.vue?macro=true";
import { default as _91token_93wc48g8hhUjMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/password-reset/[token].vue?macro=true";
import { default as indexlVe6k0SI0MMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/password-reset/index.vue?macro=true";
import { default as plan_45du_45siteO15U5am3Q2Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/plan-du-site.vue?macro=true";
import { default as politique_45de_45confidentialitei1C1qDTSWGMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexehdTbeoaw9Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/alertes/index.vue?macro=true";
import { default as charte_45bon_45fonctionnementmEG0IgFkm2Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as editxBe9vGUhZXMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/edit.vue?macro=true";
import { default as favorisLhcV3IApHPMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/favoris.vue?macro=true";
import { default as indexbgptUyUWOOMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/index.vue?macro=true";
import { default as missions3nsWQVRXD9Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/missions.vue?macro=true";
import { default as notificationslotVljxinIMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/notifications.vue?macro=true";
import { default as preferencesU4KiXhBH5HMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/preferences.vue?macro=true";
import { default as settings1DpAodb3nSMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/settings.vue?macro=true";
import { default as decembre_45ensembleUD9tkjAyHiMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as generiqueT1LREwoJWpMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/generique.vue?macro=true";
import { default as mgenTA0qywm94EMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/mgen.vue?macro=true";
import { default as printemps_45pour_45la_45planeteNlqhW5vn2aMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as septembre_45pour_45apprendrenlowJOqPtnMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as _91slug_93Z4wvpiihAxMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/reseaux/[slug].vue?macro=true";
import { default as index1Qx4TXIs4YMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/index.vue?macro=true";
import { default as missionsDrM0y6JWWVMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/missions.vue?macro=true";
import { default as organisationsh7oOEFWUxcMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/organisations.vue?macro=true";
import { default as participationsEiADlkfedgMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/participations.vue?macro=true";
import { default as places3kBQF2suK6Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/places.vue?macro=true";
import { default as utilisateurskdtFzQy1EOMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/utilisateurs.vue?macro=true";
import { default as google_45api_45indexingvDeEg7EfwRMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as search_45archived_45usersOZxgTyHGRfMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/search-archived-users.vue?macro=true";
import { default as transfert_45organisationbR8qhYCGaxMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as user_45reset_45context_45roleH9TE7MQcIJMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as user_45reset_45password_45linkY0R19Bi4GlMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as doublons_45organisationscaV82DML46Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as doublons_45territoiresOiOiGxRlr8Meta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as indexYOe4wmw11xMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/index.vue?macro=true";
import { default as activity_45logs5HMNKRWKfwMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/referents/activity-logs.vue?macro=true";
import { default as waiting_45actionsGCWgquTOiQMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/referents/waiting-actions.vue?macro=true";
import { default as missions_45outdatedIMrzKX3UpjMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as participations_45to_45be_45treated6QUGGrXulcMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as _91token_930UxR6EVxDcMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/temoignages/[token].vue?macro=true";
import { default as indexGaoXq6Tr2LMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/territoires/index.vue?macro=true";
import { default as _91slug_93OIf6t28MDjMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/villes/[slug].vue?macro=true";
import { default as component_45stub5gG1iwh2GCMeta } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5gG1iwh2GC } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/accessibilite.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/activites/[slug].vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editZ9BDYmxDwLMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexYjKDbbGQ2UMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addldxWt0FPQrMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexpIYVM9MA0UMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editT5P6luTmVOMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addaCHa7XruvbMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: index13C5tnu0hRMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editBlf7yMDCvNMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexA4X8wDC3bCMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addh7dmgJkjYlMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: index14rO8OiVFHMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsICxDm6CTAfMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editAzuvar4mDPMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: index8CyEFcai3zMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: adddUo0mzw85LMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexYEEAAP2ZgoMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editooAdIErDbrMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addYaDY090ApsMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexxmpJicPyY3Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editkIYnVF5eFeMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexrtGEGgk97dMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addQjRooXz8SWMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexgqP448s5HzMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editmVRy6HGwMZMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexOjN4TfRDmRMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexP0AzkBXjJCMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/index.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationszDiT0xr2wRMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevoleswA52jTHp6cMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesQfMlt1vnZxMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexO70ptcbQ46Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsJxX0gUbSZCMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxBPb90942j5Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsables3YHF51zEULMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleVWX8wZxjJIMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexZFJYnf1s6wMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelyNgDTNTkj3Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexEH8r8OcFZVMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/missions/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesDwzqguMzZHMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/notes.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsEiL13ObrtaMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editjM3sVEp0wlMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexkcfJ6Bh6jmMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addp4AqtDeFkkMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexaeSuofa6osMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitations3L3wJf269TMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsmvIhhmbifVMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/other/logs.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexUH9eNgevgMMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/participations/index.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/ressources.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsJ8ZSiYvD8aMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/emails.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesHkyq3d4E16Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: edit1RrMAosDDuMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45items7GgpAwS9i8Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addpj5eqfrtBcMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexD0T62kdw6mMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/settings/rules/index.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrant3VttttFMI0Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortant3FnEghnPioMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsY0jC1Pr03dMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerLicxeDwDugMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesX5pb4OrQYkMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerH7sUP4zkDPMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexmSy5SMRgonMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clescWXojrS7PxMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsqgH4Rpt5eOMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexVckT9IlyvUMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesxWgJjmNwrWMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerwTt64Aw5c8Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesc2T2JCJ4B8Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsIrLHNIrSpXMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/participations.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesCB333CxIqvMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsh6Rl33nPIRMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursQDolqD7OGVMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editoC6pCd3dBLMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: add6wYrCYcPaYMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: index9QAZ4uOHUmMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/temoignages.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editX1xPT6XxooMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexB6jNyg8sLuMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexYCrZaghJWlMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/associations/[slug].vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/charte-reserve-civique.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexCrtR51D8F4Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/dashboard/index.vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/departements/[slug].vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/domaines-action/[slug].vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/en-ce-moment.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexOfaOObQXQLMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/index.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesFbp85HYJ42Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesAVhUebn1QGMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesAs2VMDZjSdMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profilebN2WFp0XWiMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexkvoMtPseFdMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/index.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationkCzX0cfI2SMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteHHnQAVH04TMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationhZGjn1aysiMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsH3cI16jaU0Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagescXTrL31mrvMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationxozseg4f61Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileiC9MYR92IcMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93ycdj7IRycEMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/invitations/[hash].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginDj5qGS2X7WMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/login.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: admin4UbNCgiu7UMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexudKrwgck8vMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/maintenance/index.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/mentions-legales.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93c4vqxyU5JQMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/[id].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: index8dA3ECBcg0Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addVkIjW0u71lMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/modeles/add.vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexr9RAjLh5e8Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/messages/modeles/index.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexXc6YqUwGDMMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/missions-benevolat/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsIVMeRX5iroMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/notifications.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_932no4vIV64iMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/organisations/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/organisations/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93wc48g8hhUjMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/password-reset/[token].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexlVe6k0SI0MMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/password-reset/index.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/plan-du-site.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/politique-de-confidentialite.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexehdTbeoaw9Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editxBe9vGUhZXMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/edit.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisLhcV3IApHPMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/favoris.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexbgptUyUWOOMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/index.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missions3nsWQVRXD9Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/missions.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationslotVljxinIMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/notifications.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesU4KiXhBH5HMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/preferences.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settings1DpAodb3nSMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/profile/settings.vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleUD9tkjAyHiMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueT1LREwoJWpMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/generique.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenTA0qywm94EMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/mgen.vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteNlqhW5vn2aMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrenlowJOqPtnMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93Z4wvpiihAxMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/reseaux/[slug].vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: index1Qx4TXIs4YMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/index.vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsDrM0y6JWWVMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/missions.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsh7oOEFWUxcMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/organisations.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsEiADlkfedgMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/participations.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: places3kBQF2suK6Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/places.vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateurskdtFzQy1EOMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/stats/utilisateurs.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingvDeEg7EfwRMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersOZxgTyHGRfMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationbR8qhYCGaxMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45roleH9TE7MQcIJMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkY0R19Bi4GlMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationscaV82DML46Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresOiOiGxRlr8Meta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexYOe4wmw11xMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logs5HMNKRWKfwMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/referents/activity-logs.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsGCWgquTOiQMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedIMrzKX3UpjMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treated6QUGGrXulcMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_930UxR6EVxDcMeta || {},
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/temoignages/[token].vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/territoires/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/pages/villes/[slug].vue")
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/user/settings",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/statistiques",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub5gG1iwh2GC
  },
  {
    name: component_45stub5gG1iwh2GCMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub5gG1iwh2GC
  }
]